
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useRouter } from 'next/router';
import React from 'react';
import styles from './post-body.module.css';
import formatDate from '@/lib/formatDate';
import Breadcrumbs from '@/components/atoms/Breadcrumbs';
import CallToAction from '@/components/CallToAction';
import Footer from '@/components/layout/Footer';
import LandingPageNavigation from '@/components/layout/LandingPageNavigation';
import Seo from '@/components/Seo';
import { getAllPostsWithSlug, getPostAndMorePosts } from '@/utils/wordpress';
import { Avatar, PostPreview } from '.';
import NotFoundPage from '../404';
const Post = ({ post, posts, preview }: any) => {
    const router = useRouter();
    const morePosts = posts?.edges;
    if (!router.isFallback && (!post?.slug || !post?.title)) {
        return <NotFoundPage />;
    }
    if (!post?.title) {
        return <NotFoundPage />;
    }
    return (<main className='dark:bg-slate-900'>
      <Seo templateTitle={post.title} description={post.excerpt?.replace(/<[^>]*>/g, '').trim()} image={post.featuredImage?.node.sourceUrl}/>
      <div className='relative  '>
        <div className='mx-auto'>
          <div className='relative z-10  pb-8 sm:pb-16 md:pb-20 lg:w-full '>
            <LandingPageNavigation />
          </div>
        </div>
      </div>
      {router.isFallback ? (<>Loading…</>) : (<>
          <article className='mx-auto w-full max-w-3xl px-4 sm:px-6 lg:px-8 '>
            <div className='mb-10'>
              <Breadcrumbs pages={[
                { name: 'Blog', href: '/blog', current: false },
                { name: post.title, href: '', current: true },
            ]}/>
            </div>
            <PostHeader title={post.title} coverImage={post.featuredImage} date={post.date} modified={post.modified} author={post.author} categories={post.categories}/>
            <PostBody content={post.content}/>
          </article>

          <SectionSeparator />

          <CallToAction />

          {morePosts.length > 0 && <MoreStories posts={morePosts}/>}
        </>)}
      <Footer />
    </main>);
};
function MoreStories({ posts }: any) {
    return (<section className='relative mx-auto mb-14 max-w-7xl'>
      <div className='text-center'>
        <h2 className='text-3xl font-bold tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
          More Stories
        </h2>
      </div>
      <div className='mx-auto mt-12 grid max-w-lg gap-5 lg:max-w-none lg:grid-cols-3'>
        {posts.map(({ node }: any) => (<PostPreview key={node.slug} title={node.title} coverImage={node.featuredImage} date={node.date} author={node.author} slug={node.slug} excerpt={node.excerpt}/>))}
      </div>
    </section>);
}
function PostBody({ content }: any) {
    return (<div className='mx-auto max-w-3xl'>
      <div className={styles.content} dangerouslySetInnerHTML={{
            __html: content.replace(/<img.*?src="(.*?)".*?>/g, '<img src="https://easy-peasy.ai/cdn-cgi/image/quality=95,format=auto,width=1000/$1" />'),
        }}/>
    </div>);
}
function SectionSeparator() {
    return <hr className='mb-24  mt-28 border-gray-300 dark:border-white/25'/>;
}
function PostTitle({ children }: any) {
    return (<h1 className='mb-3 text-3xl font-bold leading-8 tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl' dangerouslySetInnerHTML={{ __html: children }}/>);
}
function PostHeader({ title, coverImage, date, modified, author, categories, }: any) {
    // Check if the post was updated (modified date is different from posted date)
    const wasUpdated = modified && date && formatDate(modified) !== formatDate(date);
    return (<div className='mx-auto max-w-prose text-lg'>
      <PostTitle>{title}</PostTitle>
      <div className='hidden md:mb-6 md:block'></div>
      <div className='mx-auto max-w-3xl'>
        {/* <div className='block mb-6 mt-6'>
          <Avatar author={author} />
        </div> */}
        <div className='mb-6 text-sm text-zinc-400 dark:text-zinc-500'>
          Posted {formatDate(date)}
          {wasUpdated && <> · Updated {formatDate(modified)}</>}
          <Avatar author={author}/>
          {/* <Categories categories={categories} /> */}
        </div>
      </div>
    </div>);
}
const getStaticProps = async ({ params, preview = false, previewData, locale, }: any) => {
    const data = await getPostAndMorePosts(params?.slug, preview, previewData);
    //redirect 301 to the /blog
    if (locale !== 'en') {
        return {
            redirect: {
                destination: `/blog`,
                permanent: true,
            },
        };
    }
    if (!data || !data.post.title) {
        return {
            notFound: true,
        };
    }
    return {
        props: {
            preview,
            post: data.post,
            posts: data.posts,
        },
        revalidate: 10,
    };
};
export const getStaticPaths = async () => {
    const allPosts = await getAllPostsWithSlug();
    console.log(allPosts.edges);
    return {
        paths: allPosts.edges.map(({ node }: any) => {
            return {
                params: { slug: `${node.slug}` },
            };
        }) || [],
        fallback: true,
    };
};
export default Post;

    async function __Next_Translate__getStaticProps__1a0cbfb6539__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/blog/[slug]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a0cbfb6539__ as getStaticProps }
  